<template>
  <div class="sf-grid">
    <div class="sf-row sf-row-center">
      <div class="sf-col sf-xs-6">
        <div
          class="
            sf-layer-white
            sf-pad-3
            sf-title
            sf-font-l
            sf-align-c
            sf-truncate
            sf-overflow-hidden
          "
        >
          <span v-if="done">Done!</span>
          <span v-else>Progress</span>
          <div :class="cssProgressClass">
            <div
              class="sf-progress-complete sf-bg-primary"
              :style="cssProgressStyle"
            >
              &nbsp;{{ progress }}%
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  props: {
    channelName: {
      type: String,
      required: true,
    },
    lastChannelId: {
      type: Number,
      required: true,
    },

    initialProgress: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      progress: 0,
    }
  },

  computed: {
    cssProgressStyle() {
      return `width: ${this.progress}%`
    },

    cssProgressClass() {
      const classes = ['sf-progress', 'sf-bg-snow']
      if (!this.done) {
        classes.push('sf-progress-animate')
      }
      return classes.join(' ')
    },

    done() {
      return this.progress === 100
    },
  },

  created() {
    this.progress = this.initialProgress
    this.subscribe()
  },

  beforeUnmount() {
    this.unsubscribe()
  },

  methods: {
    subscribe() {
      if (this.done) {
        return
      }

      window.Silverfin.Polling.subscribe(
        this.channelName,
        this.receiveProgress,
        this.lastChannelId
      )
    },

    unsubscribe() {
      window.Silverfin.Polling.unsubscribe(
        this.channelName,
        this.receiveProgress
      )
    },

    receiveProgress(data) {
      this.progress = data.progress

      if (this.done) {
        this.unsubscribe()
      }
    },
  },
}
</script>
